import { SalaryGroupHead } from '@/plugins/api'
import { rangeRight } from 'lodash'
export default {
  namespaced: true,
  state: {
    groupHeadfees: [],
    totalItems: 0,
    itemsPerPage: 5,
    loading: false,
    groupHeadfeesSearchParams: {},
    pageText: '',

  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage, id }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.groupHeadfeesSearchParams) {
        const groupHeadfeesSearchParams = {
          ...state.groupHeadfeesSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:desc',
          group: id
        }
        const [totalItems, groups] = await Promise.all([
          SalaryGroupHead.count(groupHeadfeesSearchParams),
          SalaryGroupHead.search(groupHeadfeesSearchParams)
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            groupHeadfees: groups,
            totalItems,
            itemsPerPage,
            groupHeadfeesSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    }
  }
}
